import { CloseCircleOutlined } from '@ant-design/icons';

import { type ConditionNodeReturnProps } from './useConditionNodeConfig';

export default function useElse(): ConditionNodeReturnProps {
  return {
    icon: CloseCircleOutlined,
    dangerIcon: true,
    hasErrors: false,
    errorMessages: [],
    targetHandle: {},
    canOpenMenu: false,
    canDelete: false,
  };
}
